// eslint-disable-next-line import/prefer-default-export
export const currency = (value, locales = 'de-DE', options = {}) => new Intl.NumberFormat(locales, {
  currency: 'EUR',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  ...options,
  style: 'currency'
}).format(value)
